import { SparePage } from "./SparePage";

const Spare = () => {
	return <SparePage />;
};
export default Spare;
